import React, { useEffect, useState } from 'react';
import { Text, ThemeProvider, ToasterComponent, ToasterProvider } from '@gravity-ui/uikit';
import { useQuery } from '@tanstack/react-query';
import { Page } from './components/Page/Page';
import { AuthLoading } from './components/AuthLoading/AuthLoading';
import { Header } from './components/Header/Header';
import { Footer } from './components/Footer/Footer';
import './App.css';
import { useTheme } from './hooks/useTheme';
import { useIsMobile } from './hooks/useIsMobile';
import { UserService } from './api/api-services/user-service/userService';
import { UserSettings } from './types/user/UserSettings';
import { toaster } from './libs/toasts/toasts';
import { applyBugVisibility } from './libs/bug-handlers/handleBugVisibility';

function App() {
    const [userSettings, setUserSettings] = useState<UserSettings>({
        notifications_type: 'EMAIL',
    });
    const userInfo = useQuery(['my-profile'], UserService.getUserInfo, {
        onSuccess: ({ settings }) => {
            setUserSettings(settings);
        },
    });
    const { theme, toggleTheme } = useTheme();
    const isMobile = useIsMobile();

    useEffect(() => {
        applyBugVisibility();
    }, []);

    useEffect(() => {
        document.body.setAttribute('data-theme', theme);
    }, [theme]);

    if (userInfo.isLoading) {
        return <AuthLoading />;
    }

    if (userInfo.isError) {
        return (
            <div className="App-auth-container">
                <Text>Упс. Что-то пошло не так</Text>
            </div>
        );
    }

    return (
        <ThemeProvider theme={theme}>
            <ToasterProvider toaster={toaster}>
                <div className="App">
                    <Header
                        avatar={userInfo.data.avatar}
                        settings={userSettings}
                        setSettings={setUserSettings}
                        theme={theme}
                        toggleTheme={toggleTheme}
                    />
                    <Page isMobile={isMobile} />
                    {isMobile ? null : <Footer />}
                </div>
                <ToasterComponent />
            </ToasterProvider>
        </ThemeProvider>
    );
}

export default App;
